import { render, staticRenderFns } from "./CguDialog.vue?vue&type=template&id=8290758e&"
import script from "./CguDialog.vue?vue&type=script&lang=js&"
export * from "./CguDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports